class CartDrawer extends Drawer {
    constructor() {
        super();

        this.isDesktop = window.innerWidth > 1024;
        if (!this.isDesktop) this.classList.add('is-mobile');

        const opener =  document.querySelector('#cart-icon-bubble');
        this.setIconAccessibility(opener);
        this.setContentHeight()

        subscribe(PUB_SUB_EVENTS.cartUpdate,() => {
            super.setListeners()
            setTimeout(() => {

                this.setContentHeight()
            })
        })
    }

    open() {
        super.open()
        const announcement = document.querySelector('.mc-announcement-bar-section');    
        const rect = announcement.getBoundingClientRect();
        const height = Math.max(0, Math.min(rect.bottom, rect.height, window.innerHeight - Math.max(0, rect.top)));
        document.documentElement.style.setProperty('--cart-drawer-top', `${height || 0}px`);
    }

    setContentHeight() {
        const drowerHeaderH = this.querySelector('.drawer__header').offsetHeight ;
        const drowerFooterH = this.querySelector('[data-drawer-footer]').offsetHeight  ;

        const drowerContentH = parseInt(window.innerHeight - drowerFooterH - drowerHeaderH);
        document.documentElement.style.setProperty('--cart-drawer-content-height', `${drowerContentH || 0}px`);    
    }

    renderContents(parsedState) {
        const details = this.querySelector('[data-details]')
        details.classList.contains('is-empty') &&
        details.classList.remove('is-empty');
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);

            if (!sectionElement) return;
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });

        setTimeout(() => {
            this.querySelector('[data-overlay]').addEventListener('click', this.close.bind(this));
            this.open();
            super.setListeners()
        });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-drawer',
                selector: '#CartDrawer',
            },
            {
                id: 'cart-icon-bubble',
            },
        ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [
            {
                id: 'CartDrawer',
                section: 'cart-drawer',
                selector: '[data-details]',
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section',
            },
        ];
    }
}

customElements.define('cart-drawer-items', CartDrawerItems);
